module.exports = __webpack_public_path__ + "static/media/The_Mix2.876b53a5.png";